module.exports = __webpack_public_path__ + "static/media/seed9.72713758.svg";